export default "__VITE_ASSET__BNUJWU6M__"